/**
 * Wraps an async handler so that concurrent/duplicate invocations while
 * one call is still in flight are ignored. Use this to guard Save/Submit
 * handlers against double-click / double-submit creating duplicate records.
 *
 * Usage:
 *   private saveEvidence = createSubmitGuard(async (): Promise<void> => {
 *       ...
 *   });
 */
export function createSubmitGuard<T extends (...args: any[]) => Promise<any> | void>(
    fn: T
): T {
    let isRunning = false;

    return (async (...args: any[]) => {
        if (isRunning) {
            return;
        }

        isRunning = true;

        try {
            return await fn(...args);
        }
        finally {
            isRunning = false;
        }
    }) as T;
}